var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2125_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1893 37C19.6893 37 37.1893 19 37.1893 17C37.1893 19 54.6893 37 57.1893 37C54.6893 37 37.1893 55 37.1893 57C37.1893 55 19.6893 37 17.1893 37Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.329 197.168C113.875 197.168 111.079 194.368 111.079 190.918C111.079 182.844 116.712 175.465 127.366 169.594C135.303 165.22 139.411 156.549 137.824 147.508C136.357 139.163 129.503 132.309 121.158 130.842C115.137 129.784 109.221 131.226 104.488 134.9C99.8425 138.513 96.9218 143.917 96.4802 149.729C96.2177 153.166 93.2095 155.749 89.7764 155.487C86.3349 155.224 83.7559 152.225 84.0184 148.783C84.7267 139.463 89.3931 130.805 96.8218 125.034C104.371 119.164 113.783 116.86 123.316 118.531C136.749 120.889 147.777 131.917 150.136 145.35C152.623 159.512 145.894 173.657 133.399 180.544C127.249 183.931 123.579 187.81 123.579 190.918C123.579 194.368 120.783 197.168 117.329 197.168ZM111.079 211.75C111.079 215.2 113.879 218 117.329 218C120.779 218 123.579 215.2 123.579 211.75C123.579 208.301 120.779 205.501 117.329 205.501C113.879 205.501 111.079 208.301 111.079 211.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2125_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.189 299C168.689 299 186.189 281 186.189 279C186.189 281 203.689 299 206.189 299C203.689 299 186.189 317 186.189 319C186.189 317 168.689 299 166.189 299Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2125_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2125_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(166 279)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionD);
export default __webpack_public_path__ + "static/media/QuestionD.263d2205f4a5fac2cba364f6121ceb05.svg";
export { ForwardRef as ReactComponent };